module.exports = __webpack_public_path__ + "static/img/bg3-hover.7989b84b.png";